<template>
  <div class="d-flex flex-row justify-end">
    <v-btn v-if="cancelVisible" @click="onCancel" :disabled="cancelDisabled" class="mr-2">{{cancelText}}</v-btn>
    <v-btn v-if="confirmVisible" @click="onConfirm" :disabled="confirmDisabled" color="success">{{confirmText}}</v-btn>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class DynameatModalButtons extends Vue {
  @Prop({ Boolean, default: true }) cancelVisible;

  @Prop({ Boolean, default: true }) confirmVisible;

  @Prop({ Boolean, default: false }) confirmDisabled;

  @Prop({ Boolean, default: false }) cancelDisabled;

  @Prop({ type: String, default() { return this.$t('cancel'); } }) cancelText;

  @Prop({ type: String, default() { return this.$t('confirm'); } }) confirmText;

  onCancel() {
    this.$emit('cancel');
  }

  onConfirm() {
    this.$emit('confirm');
  }
}
</script>
